module.exports = __webpack_public_path__ + "img/244.9386cb42.jpg";